(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-style-1"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('gf-cart')) customElements.define('gf-cart', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.pending = new Map();
    this.noteValue = this.querySelector('[data-cart-note]')?.value || '';
    this.noteDirty = false;
    this.running = false;
    this.unconfirmed = false;
    this.header = document.querySelector('[data-gf-store-header]');
    const offset = () => this.style.setProperty('--gf-cart-header', `${this.header ? Math.ceil(this.header.getBoundingClientRect().height) : 0}px`);
    offset();
    if (this.header && typeof ResizeObserver === 'function') { this.observer = new ResizeObserver(offset); this.observer.observe(this.header); }
    this.addEventListener('click', event => this.onClick(event));
    this.addEventListener('input', event => this.onInput(event));
    this.addEventListener('change', event => { if (event.target.matches('[data-cart-input]')) this.drain(); });
    this.addEventListener('submit', event => this.onSubmit(event));
    this.pageshow = () => { this.navigating = false; this.setBusy(); };
    window.addEventListener('pageshow', this.pageshow);
    this.setBusy();
  }
  disconnectedCallback() { this.observer?.disconnect(); clearTimeout(this.timer); window.removeEventListener('pageshow', this.pageshow); }
  status(text) { const element = this.querySelector('[data-cart-status]'); if (element) element.textContent = text; }
  error(text) { const panel = this.querySelector('[data-cart-error]'); if (panel) { panel.hidden = !text; panel.querySelector('[data-cart-error-text]').textContent = text; } }
  setBusy() {
    const busy = this.running || this.pending.size > 0 || this.noteDirty;
    this.setAttribute('aria-busy', String(busy));
    const blocked = this.querySelector('[data-cart-summary]')?.dataset.blocked === 'true';
    this.querySelectorAll('[data-cart-checkout]').forEach(button => { button.disabled = busy || blocked || this.unconfirmed; });
    const express = this.querySelector('[data-cart-express]');
    if (express) express.inert = busy || blocked || this.unconfirmed;
    this.querySelectorAll('[data-cart-step]').forEach(button => {
      const input = button.closest('[data-cart-key]').querySelector('[data-cart-input]');
      const boundary = button.dataset.cartStep === 'minus' ? Number(input.value) <= Number(input.min || 1) : input.max && Number(input.value) >= Number(input.max);
      button.disabled = this.running || Boolean(boundary);
    });
    this.querySelectorAll('[data-cart-input]').forEach(input => { input.readOnly = this.running; });
    const note = this.querySelector('[data-cart-note]');
    if (note) note.readOnly = this.running;
    this.querySelectorAll('[data-cart-remove]').forEach(link => { link.setAttribute('aria-disabled', String(this.running)); });
  }
  onClick(event) {
    const step = event.target.closest('[data-cart-step]');
    const remove = event.target.closest('[data-cart-remove]');
    if (step || remove) {
      event.preventDefault();
      if (this.running) return;
      const row = (step || remove).closest('[data-cart-key]');
      if (remove) { this.pending.set(row.dataset.cartKey, {quantity:0,index:Number(row.dataset.cartIndex)}); this.focusKey = row.dataset.cartKey; this.drain(); return; }
      const input = row.querySelector('[data-cart-input]');
      const increment = Number(input.step || 1);
      const next = Number(input.value) + (step.dataset.cartStep === 'plus' ? increment : -increment);
      if (next < Number(input.min || 1) || input.max && next > Number(input.max)) return;
      input.value = String(next);
      this.queue(input);
    }
    if (event.target.closest('[data-cart-refresh]')) { event.preventDefault(); this.refreshFromServer(); }
  }
  onInput(event) {
    if (event.target.matches('[data-cart-input]')) this.queue(event.target);
    if (event.target.matches('[data-cart-note]')) {
      this.noteValue = event.target.value;
      this.noteDirty = true;
      this.error('');
      this.status(this.dataset.updating);
      this.schedule(650);
    }
  }
  queue(input) {
    const row = input.closest('[data-cart-key]');
    if (!input.value || !input.checkValidity() || !Number.isInteger(Number(input.value))) {
      this.pending.delete(row.dataset.cartKey);
      input.setAttribute('aria-invalid','true');
      this.error(this.dataset.quantityError);
      this.unconfirmed = true;
      this.setBusy();
      return;
    }
    input.removeAttribute('aria-invalid');
    this.unconfirmed = false;
    this.error('');
    this.pending.set(row.dataset.cartKey, {quantity:Number(input.value),index:Number(row.dataset.cartIndex)});
    this.focusKey = row.dataset.cartKey;
    this.status(this.dataset.updating);
    this.schedule(350);
  }
  schedule(delay) { clearTimeout(this.timer); this.setBusy(); this.timer = setTimeout(() => this.drain(), delay); }
  async request(url, body) {
    const response = await fetch(url, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.errors || data.status >= 400) {
      const error = new Error(typeof data.description === 'string' ? data.description : typeof data.errors === 'string' ? data.errors : this.dataset.error);
      throw error;
    }
    return data;
  }
  render(sections) {
    const html = sections?.[this.dataset.sectionId];
    if (typeof html !== 'string') throw new Error(this.dataset.unconfirmed);
    const next = new DOMParser().parseFromString(html,'text/html').querySelector('gf-cart');
    if (!next) throw new Error(this.dataset.unconfirmed);
    const active = document.activeElement;
    const noteFocused = active?.matches('[data-cart-note]');
    const selection = noteFocused ? active.selectionStart : null;
    const wasEmpty = this.dataset.count === '0';
    this.innerHTML = next.innerHTML;
    this.dataset.count = next.dataset.count;
    const note = this.querySelector('[data-cart-note]');
    if (note && this.noteDirty) note.value = this.noteValue;
    else if (note) this.noteValue = note.value;
    if (noteFocused && note) { note.focus({preventScroll:true}); note.setSelectionRange(selection,selection); }
    const count = document.querySelector('#cart-icon-bubble .gf-store-cart-count');
    if (count) count.textContent = `(${next.dataset.count})`;
    this.setBusy();
    if (!noteFocused && this.focusKey) {
      const row = [...this.querySelectorAll('[data-cart-key]')].find(row => row.dataset.cartKey === this.focusKey);
      const target = row?.querySelector('[data-cart-input]') || this.querySelector('[data-cart-heading]');
      target?.focus({preventScroll:next.dataset.count !== '0'});
    }
    if (!wasEmpty && next.dataset.count === '0') this.querySelector('[data-cart-heading]')?.scrollIntoView({block:'center'});
  }
  async fetchSections() {
    const url = new URL(this.dataset.cartUrl,location.origin);
    url.searchParams.set('sections',this.dataset.sectionId);
    const response = await fetch(url,{credentials:'same-origin'});
    if (!response.ok) throw new Error(this.dataset.unconfirmed);
    this.render(await response.json());
  }
  async refreshFromServer() {
    if (this.running) return;
    this.pending.clear();
    clearTimeout(this.timer);
    this.running = true; this.setBusy(); this.status(this.dataset.updating);
    try { await this.fetchSections(); this.unconfirmed = false; this.error(''); this.status(this.dataset.updated); }
    catch { this.unconfirmed = true; this.error(this.dataset.unconfirmed); }
    finally { this.running = false; this.setBusy(); }
    if (this.noteDirty && !this.unconfirmed) this.drain();
  }
  async drain() {
    clearTimeout(this.timer);
    if (this.running) return this.work;
    if (!this.pending.size && !this.noteDirty) return true;
    this.running = true; this.setBusy(); this.status(this.dataset.updating);
    this.work = (async () => {
      let adjusted = false;
      try {
        if (this.noteDirty) {
          const value = this.noteValue;
          const state = await this.request(this.dataset.updateUrl,{note:value,sections:[this.dataset.sectionId],sections_url:location.pathname});
          this.noteDirty = false;
          this.render(state.sections);
        }
        while (this.pending.size) {
          const [key,change] = this.pending.entries().next().value;
          this.pending.delete(key);
          const state = await this.request(this.dataset.changeUrl,{id:key,quantity:change.quantity,sections:[this.dataset.sectionId],sections_url:location.pathname});
          const accepted = state.items.find(item=>item.key===key)?.quantity || 0;
          if (change.quantity && accepted !== change.quantity) adjusted = true;
          this.render(state.sections);
        }
        this.unconfirmed = false;
        this.error(adjusted ? this.dataset.adjusted : '');
        this.status(this.dataset.updated);
        return true;
      } catch (error) {
        this.pending.clear();
        try { await this.fetchSections(); this.unconfirmed = false; }
        catch { this.unconfirmed = true; }
        this.error(this.unconfirmed ? this.dataset.unconfirmed : error.message || this.dataset.error);
        this.status('');
        return false;
      } finally { this.running = false; this.setBusy(); }
    })();
    return this.work;
  }
  async onSubmit(event) {
    if (this.nativeSubmit) return;
    if (this.running || this.unconfirmed || this.querySelector('[data-cart-summary]')?.dataset.blocked === 'true') { event.preventDefault(); return; }
    if (this.pending.size || this.noteDirty) {
      event.preventDefault();
      const checkout = event.submitter?.name === 'checkout';
      if (!await this.drain()) return;
      if (checkout && !this.unconfirmed && this.querySelector('[data-cart-summary]')?.dataset.blocked !== 'true') {
        this.nativeSubmit = true;
        const form = this.querySelector('[data-cart-form]');
        form?.requestSubmit(form.querySelector('[data-cart-checkout]'));
      }
      return;
    }
    if (event.submitter?.name === 'checkout') { this.status(this.dataset.checkout); this.navigating = true; }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-collection-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const setInitialState = (root) => {
      root.querySelectorAll('.gf-collection-guide__topic').forEach((topic) => { topic.open = !mobile.matches; });
    };
    setInitialState(document);
    mobile.addEventListener('change', () => setInitialState(document));
    document.addEventListener('shopify:section:load', (event) => setInitialState(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-contact"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.contactReady) return;
    const form = root.querySelector('.gf-contact-form');
    if (!form) return;
    root.dataset.contactReady = 'true';
    const fields = [...form.querySelectorAll('[data-contact-input]')];
    const state = form.querySelector('[data-contact-state]');
    const errors = form.querySelector('[data-contact-errors]');
    const list = form.querySelector('[data-contact-error-list]');
    const key = `gf-contact-draft:${location.pathname}`;
    const header = document.querySelector('[data-gf-store-header]');
    const offset = () => root.style.setProperty('--gf-contact-header', `${header ? Math.ceil(header.getBoundingClientRect().height) : 0}px`);
    offset();
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(offset) : null;
    if (header) observer?.observe(header);
    form.noValidate = true;
    const clearSaved = () => { try { sessionStorage.removeItem(key); } catch {} };
    if (state.dataset.posted === 'true') {
      clearSaved();
      fields.forEach(field => { field.value = ''; });
    } else {
      try {
        const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
        if (saved && Date.now() - saved.time < 1800000) fields.forEach(field => {
          if (typeof saved.values[field.name] !== 'string') return;
          if (field.tagName !== 'SELECT' || [...field.options].some(option => option.value === saved.values[field.name])) field.value = saved.values[field.name];
        });
        else clearSaved();
      } catch { clearSaved(); }
    }
    function fieldError(field) {
      field.setCustomValidity('');
      if (field.required && !field.value.trim()) return field.dataset.requiredError;
      if (field.validity.typeMismatch) return root.dataset.emailError;
      if (!field.validity.valid) return field.validationMessage;
      return '';
    }
    function mark(field, message) {
      const error = field.closest('.gf-contact-field').querySelector('[data-contact-field-error]');
      if (message) field.setAttribute('aria-invalid', 'true'); else field.removeAttribute('aria-invalid');
      if (error) { error.textContent = message; error.hidden = !message; }
    }
    fields.forEach(field => field.addEventListener('input', () => { if (field.hasAttribute('aria-invalid')) mark(field, fieldError(field)); }));
    form.addEventListener('submit', event => {
      list.replaceChildren();
      let invalid = false;
      fields.forEach(field => {
        const message = fieldError(field);
        mark(field, message);
        if (!message) return;
        invalid = true;
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${field.id}`;
        link.textContent = message;
        link.addEventListener('click', e => { e.preventDefault(); field.focus(); field.closest('.gf-contact-field').scrollIntoView({block:'center',behavior:'instant'}); });
        li.append(link); list.append(li);
      });
      if (!navigator.onLine) { const li = document.createElement('li'); li.textContent = root.dataset.offlineError; list.append(li); invalid = true; }
      errors.hidden = !invalid;
      if (invalid) { event.preventDefault(); errors.focus(); errors.scrollIntoView({block:'start',behavior:'instant'}); return; }
      try { sessionStorage.setItem(key, JSON.stringify({time:Date.now(),values:Object.fromEntries(fields.map(field => [field.name, field.value]))})); } catch {}
    });
    const result = form.querySelector('[data-contact-success], [data-contact-server-errors]');
    if (result) requestAnimationFrame(() => { result.focus({preventScroll:true}); result.scrollIntoView({block:'start',behavior:'instant'}); });
    root.addEventListener('shopify:section:unload', () => { observer?.disconnect(); }, {once:true});
  }
  document.querySelectorAll('[data-gf-contact]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-gf-contact]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gf-mattress-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');
    const setInitialState = (root) => {
      root.querySelectorAll('.gf-mattress-guide__topic').forEach((topic) => {
        topic.open = !mobile.matches;
      });
    };
    setInitialState(document);
    mobile.addEventListener('change', () => setInitialState(document));
    document.addEventListener('shopify:section:load', (event) => setInitialState(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if (!customElements.get('gf-collection')) customElements.define('gf-collection',class extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;
    this.ready=true;this.cache=new Map();this.draftVersion=0;this.busy=false;
    this.addEventListener('click',e=>this.click(e));
    this.addEventListener('submit',e=>this.submit(e));
    this.addEventListener('change',e=>{if(e.target.matches('[data-desktop-sort]'))e.target.form.requestSubmit();if(e.target.closest('[data-mobile-filter-form]'))this.draft();});
    this.addEventListener('input',e=>{if(e.target.closest('[data-mobile-filter-form]')&&e.target.type==='number')this.draft();});
    this.outside=e=>{if(!this.contains(e.target))this.closeDropdowns();else if(!e.target.closest('.gf-filter-dropdown'))this.closeDropdowns();};
    document.addEventListener('click',this.outside);
    this.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=this.querySelector('.gf-filter-dropdown[open]');if(open){open.open=false;open.querySelector('summary').focus();}}});
    this.pop=()=>this.update(new URL(location.href),false,true);
    window.addEventListener('popstate',this.pop);
    this.viewport=()=>this.style.setProperty('--gf-filter-viewport',`${Math.round(window.visualViewport?.height||innerHeight)}px`);this.viewport();window.visualViewport?.addEventListener('resize',this.viewport);window.addEventListener('resize',this.viewport);this.bindDialogs();
  }
  disconnectedCallback(){document.removeEventListener('click',this.outside);window.removeEventListener('popstate',this.pop);window.visualViewport?.removeEventListener('resize',this.viewport);window.removeEventListener('resize',this.viewport);clearTimeout(this.timer);this.draftAbort?.abort();this.abort?.abort();this.unlock();}
  bindDialogs(){this.querySelectorAll('dialog').forEach(dialog=>dialog.addEventListener('close',()=>{this.draftVersion++;clearTimeout(this.timer);this.draftAbort?.abort();this.unlock();}));}
  closeDropdowns(){this.querySelectorAll('.gf-filter-dropdown[open]').forEach(d=>d.open=false);}
  unlock(){if(this.locked){document.body.style.overflow=this.previousOverflow;this.locked=false;}}
  open(kind,button){const dialog=this.querySelector(`[data-filter-dialog="${kind}"]`);if(!dialog)return;this.trigger=button;dialog.querySelector('form').reset();dialog.querySelectorAll('input[type=checkbox]').forEach(input=>{const original=[...this.querySelectorAll('[data-filter-form] input[type=checkbox]')].find(i=>i.name===input.name&&i.value===input.value);if(original){input.disabled=original.disabled;input.closest('label').querySelector('[data-choice-count]').textContent=original.closest('label').querySelector('[data-choice-count]').textContent;}});this.draftReady=true;this.draftVersion++;this.selection();const status=dialog.querySelector('[data-draft-status]');if(status)status.textContent='';const error=dialog.querySelector('[data-draft-error]');if(error)error.hidden=true;const show=dialog.querySelector('[data-show-results]');if(show){show.disabled=false;show.textContent=this.dataset.show.replace('__COUNT__',this.dataset.count);}this.previousOverflow=document.body.style.overflow;this.locked=true;document.body.style.overflow='hidden';dialog.showModal();}
  close(dialog){dialog?.close();this.trigger?.focus({preventScroll:true});}
  click(e){
    const open=e.target.closest('[data-open-dialog]');if(open){this.open(open.dataset.openDialog,open);return;}
    const close=e.target.closest('[data-close-dialog]');if(close){this.close(close.closest('dialog'));return;}
    if(e.target.matches('dialog')){const rect=e.target.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)this.close(e.target);}
    const summary=e.target.closest('.gf-filter-dropdown>summary');if(summary)this.querySelectorAll('.gf-filter-dropdown[open]').forEach(d=>{if(d!==summary.parentElement)d.open=false;});
    const link=e.target.closest('[data-filter-link],[data-filter-pagination] a[href]');if(link&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey){e.preventDefault();this.update(new URL(link.href,location.href),true,!!link.closest('[data-filter-pagination]'));}
    if(e.target.closest('[data-draft-clear]')){const form=this.querySelector('[data-mobile-filter-form]');form.querySelectorAll('input[type=checkbox]').forEach(i=>i.checked=false);form.querySelectorAll('input[type=number]').forEach(i=>i.value='');this.draft();}
    if(e.target.closest('[data-draft-retry]'))this.draft();
    if(e.target.closest('[data-filter-retry]')&&this.retryURL)this.update(this.retryURL,true,false);
  }
  selection(){this.querySelectorAll('[data-draft-group]').forEach(group=>{const count=group.querySelectorAll('input[type=checkbox]:checked').length;const numeric=[...group.querySelectorAll('input[type=number]')].some(i=>i.value!=='');group.querySelector('[data-draft-selection]').textContent=count||numeric?this.dataset.selected.replace('__COUNT__',count||1):'';});}
  url(form){const url=new URL(location.href);[...url.searchParams.keys()].forEach(key=>{if(key.startsWith('filter.')||key==='sort_by'||key==='page')url.searchParams.delete(key);});for(const[key,value]of new FormData(form)){if(String(value).trim()!=='')url.searchParams.append(key,value);}url.hash='';return url;}
  valid(form){if(!form.checkValidity()){form.reportValidity();return false;}const min=form.querySelector('[data-price-min]'),max=form.querySelector('[data-price-max]');if(min&&max&&min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value))return false;return true;}
  async html(url,signal){const key=url.pathname+url.search;if(this.cache.has(key))return this.cache.get(key);const request=new URL(url);request.searchParams.set('section_id',this.dataset.sectionId);const response=await fetch(request,{signal,credentials:'same-origin'});if(!response.ok)throw new Error();const source=await response.text();const root=new DOMParser().parseFromString(source,'text/html').querySelector('gf-collection');if(!root)throw new Error();if(this.cache.size>6)this.cache.delete(this.cache.keys().next().value);this.cache.set(key,root);return root;}
  async draft(){
    const form=this.querySelector('[data-mobile-filter-form]');this.selection();clearTimeout(this.timer);this.draftAbort?.abort();const version=++this.draftVersion;this.draftReady=false;
    const show=form.querySelector('[data-show-results]'),error=form.querySelector('[data-draft-error]');show.disabled=true;error.hidden=true;
    const min=form.querySelector('[data-price-min]'),max=form.querySelector('[data-price-max]');const invalid=[...form.querySelectorAll('input[type=number]')].some(i=>!i.checkValidity())||min&&max&&min.value!==''&&max.value!==''&&Number(min.value)>Number(max.value);
    if(invalid){error.hidden=false;error.querySelector('p').textContent=this.dataset.priceError;return;}
    form.querySelector('[data-draft-status]').textContent=this.dataset.loading;
    this.timer=setTimeout(async()=>{this.draftAbort=new AbortController();try{const next=await this.html(this.url(form),this.draftAbort.signal);if(version!==this.draftVersion)return;show.textContent=this.dataset.show.replace('__COUNT__',next.dataset.count);show.disabled=false;this.draftReady=true;form.querySelector('[data-draft-status]').textContent='';const values=[...next.querySelectorAll('[data-mobile-filter-form] input[type=checkbox]')];form.querySelectorAll('input[type=checkbox]').forEach(input=>{const match=values.find(i=>i.name===input.name&&i.value===input.value);input.disabled=!input.checked&&(!match||match.disabled);const count=input.closest('label').querySelector('[data-choice-count]');if(count&&match)count.textContent=match.closest('label').querySelector('[data-choice-count]').textContent;});}catch(e){if(e.name==='AbortError'||version!==this.draftVersion)return;form.querySelector('[data-draft-status]').textContent='';error.hidden=false;error.querySelector('p').textContent=this.dataset.draftError;}},350);
  }
  submit(e){const form=e.target;if(!form.matches('[data-filter-form],[data-mobile-filter-form],[data-mobile-sort-form]'))return;e.preventDefault();if(this.busy)return;if(!this.valid(form)){if(form.matches('[data-mobile-filter-form]')){const panel=form.querySelector('[data-draft-error]');panel.hidden=false;panel.querySelector('p').textContent=this.dataset.priceError;}else this.error(this.dataset.priceError);return;}if(form.matches('[data-mobile-filter-form]')&&!this.draftReady)return;this.update(this.url(form),true,false);}
  error(message){this.querySelectorAll('[data-filter-error],[data-dialog-error]').forEach(panel=>{panel.hidden=!message;panel.querySelector('[data-filter-error-text]').textContent=message;});}
  async update(url,push,scroll){
    this.abort?.abort();this.abort=new AbortController();this.busy=true;this.retryURL=url;this.setAttribute('aria-busy','true');this.error('');this.querySelector('[data-filter-status]').textContent=this.dataset.loading;this.querySelectorAll('button[type=submit]').forEach(b=>b.disabled=true);
    try{const next=await this.html(url,this.abort.signal);const grid=this.querySelector('#ProductGridContainer'),replacement=next.querySelector('#ProductGridContainer');grid.replaceChildren(...replacement.cloneNode(true).childNodes);const fragment=next.cloneNode(true);fragment.querySelector('#ProductGridContainer').replaceWith(grid);this.querySelectorAll('dialog[open]').forEach(d=>d.close());this.unlock();this.replaceChildren(...fragment.childNodes);this.dataset.count=next.dataset.count;this.bindDialogs();if(push)history.pushState({},'',url.pathname+url.search);this.querySelector('[data-filter-status]').textContent=this.dataset.updated.replace('__COUNT__',next.dataset.count);if(scroll){grid.focus({preventScroll:true});grid.scrollIntoView({block:'start',behavior:'auto'});}else{const target=this.querySelector(matchMedia('(max-width:749px)').matches?'[data-open-dialog="filters"]':'[data-desktop-sort]');target?.focus({preventScroll:true});}}
    catch(e){if(e.name==='AbortError')return;this.error(this.dataset.error);this.querySelector('[data-filter-status]').textContent='';this.querySelectorAll('button[type=submit]').forEach(b=>b.disabled=false);}
    finally{this.busy=false;this.setAttribute('aria-busy','false');}
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
